import { IndirectSeedTypeGq } from './IndirectSeedTypeGq';
import { KeywordDomainRankGq, KeywordDomainRankGqProps } from './KeywordDomainRankGq';
import { ProjectKeywordMonthGq, ProjectKeywordMonthGqProps } from './ProjectKeywordMonthGq';
import { ProjectKeywordVariantGq, ProjectKeywordVariantGqProps } from './ProjectKeywordVariantGq';
import { QueuedItemStatus } from './QueuedItemStatus';
import { SerpStatusGq } from './SerpStatusGq';
import {
  SerpTrackingKeywordRankGq,
  SerpTrackingKeywordRankGqProps,
} from './SerpTrackingKeywordRankGq';
import { SerpTrackingRequestGq, SerpTrackingRequestGqProps } from './SerpTrackingRequestGq';

export interface ProjectKeywordGq {
  id: number;
  keyword: string;
  indirectSeed?: string;
  indirectSeedType?: IndirectSeedTypeGq;
  requestId: number;
  archived: boolean;
  manualArchiveState: boolean;
  archiveTime?: string;
  serpEnabled: boolean;
  serpTaskTime?: string;
  serpResultTime?: string;
  serpStatus: SerpStatusGq;
  domainSerpTaskTime?: string;
  domainSerpResultTime?: string;
  fetchingNewVolume: boolean;
  cPC: number;
  bidHigh: number;
  bidLow: number;
  volume: number;
  trend?: number;
  peakQuarter?: number;
  peakMonth?: number;
  competition: number;
  processingTime?: string;
  domainRanks: KeywordDomainRankGq[];
  tags: number[];
  translatedFromKeyword?: string;
  translatedFromVolume?: number;
  translationEnglish?: string;
  translationEnglishQueued: boolean;
  translationEnglishCompleted: boolean;
  months2: number[];
  serpTrackingKeywordRanks?: SerpTrackingKeywordRankGq[];
  serpTrackingRequests?: SerpTrackingRequestGq[];
  serpHasFeaturedSnippet: boolean; // Legacy†
  serpFeaturesSet1?: number;
  serpFeaturesSet2?: number;
  keywordVariants?: ProjectKeywordVariantGq[];
  variantStatus?: QueuedItemStatus;
}

export const ProjectKeywordGqProps = `
  id
  keyword
  indirectSeed
  indirectSeedType
  requestId
  archived
  archiveTime
  manualArchiveState
  serpEnabled
  serpTaskTime
  serpResultTime
  serpStatus
  domainSerpTaskTime
  domainSerpResultTime
  fetchingNewVolume
  cPC
  bidHigh
  bidLow
  volume
  trend
  peakQuarter
  peakMonth
  competition
  processingTime
  domainRanks { ${KeywordDomainRankGqProps} }
  tags
  translatedFromKeyword
  translatedFromVolume
  translationEnglish
  translationEnglishQueued
  translationEnglishCompleted
  months2
  serpTrackingKeywordRanks { ${SerpTrackingKeywordRankGqProps} }
  serpTrackingRequests {${SerpTrackingRequestGqProps}}
  serpHasFeaturedSnippet
  serpFeaturesSet1
  serpFeaturesSet2
  keywordVariants { ${ProjectKeywordVariantGqProps} }
  variantStatus
`;
